import { gsap } from "gsap";
import { Sprite, Texture } from "pixi.js";

import { AbstractSpine } from "../../../../abstracts/graphics/AbstractSpine";
import { playSound } from "../../../../abstracts/utils/SoundUtils";
import { symbolConfig } from "../../../config/ApocalypseConfig";
import { ApocalypseSymbolNames } from "../../../types/ApocalypseEnums";
import { ApocalypseSymbol } from "./ApocalypseSymbol";

export class ApocalypseXNudgeSymbol extends ApocalypseSymbol {
    constructor() {
        super(ApocalypseSymbolNames.XNUDGE);
    }

    protected generateSymbol() {
        this.mainSpine = new AbstractSpine(`spine/Apocalypse/xnudge.json`);
        this.mainSpine.getSpineTween(`Normal`);

        this.mainSpineDefaultXPosition = symbolConfig.symbolWidth / 2;
        this.mainSpineDefaultYPosition = symbolConfig.symbolHeight / 2;

        this.mainTextureDefaultName = `Apocalypse/NUDGE_x1`;

        this.mainTextureSprite = new Sprite(Texture.from(this.mainTextureDefaultName));
        this.mainTextureSprite.name = `mainTextureSprite`;
        this.mainTextureSprite.scale.set(0.5);
        this.mainTextureSprite.alpha = 1;

        this.mainTextureDefaultXPosition =
            symbolConfig.symbolWidth / 2 - this.mainTextureSprite.width / 2;
        this.mainTextureDefaultYPosition =
            symbolConfig.symbolHeight - this.mainTextureSprite.height - 1;

        this.addChild(this.mainTextureSprite);

        this.mainSpine.x = this.mainSpineDefaultXPosition;
        this.mainSpine.y = this.mainSpineDefaultYPosition;

        this.mainTextureSprite.x = this.mainTextureDefaultXPosition;
        this.mainTextureSprite.y = this.mainTextureDefaultYPosition;
    }

    override getLandingAnimation(): gsap.core.Tween | gsap.core.Timeline {
        this.addChild(this.mainSpine);
        this.removeChild(this.mainTextureSprite);

        return this.mainSpine.getSpineTween(`Landing`, false, () => {
            playSound({ name: `Nudge${4 - this.reelPosition}xLightUp` });
        });
    }

    public override getWinAnimation(): gsap.core.Tween | gsap.core.Timeline {
        const symbolAnimation = this.mainSpine.getSpineTween(
            `x${4 - this.reelPosition}_idle`,
            true,
            () => {
                this.mainSpine.tint = 0xffffff;
                this.removeChild(this.mainTextureSprite);
                this.addChild(this.mainSpine);
            }
        );

        symbolAnimation.timeScale(1.15);

        return symbolAnimation;
    }

    public getNoWinAnimation(): gsap.core.Tween | gsap.core.Timeline {
        const tl = gsap.timeline({
            smoothChildTiming: true,
        });

        const symbolAnimation = gsap.to(this.mainSpine, {
            pixi: { tint: 0x555555 },
            duration: 0.1,
        });

        tl.add(this.getStaticAnimation(), 0);

        tl.add(symbolAnimation, 0.01);

        return tl;
    }

    public getStopWinAnimation(): gsap.core.Tween {
        return this.mainSpine.getSpineTween(`Normal`);
    }

    public override getXNudgeAnimation(
        animationName: string = ``,
        animationId: number = 0
    ): gsap.core.Timeline | gsap.core.Tween {
        this.isActivated = true;
        return this.mainSpine.getSpineTween(`x${animationId}`, false, () => {
            this.removeChild(this.mainTextureSprite);
            this.addChild(this.mainSpine);
            playSound({ name: `xNudgeX${animationId}` });
        });
    }

    public getIdleAnimation(): gsap.core.Tween {
        return this.mainSpine.getSpineTween(`x${4 - this.reelPosition}_idle`, true);
    }

    public getStaticAnimation(): gsap.core.Tween {
        return this.mainSpine.getSpineTween(`x${4 - this.reelPosition}_static`, false);
    }

    override reset() {
        super.reset();
        this.isActivated = false;
        this.size = 1;
    }

    resetOnStartSpin() {
        if (this.mainSpine !== undefined) {
            this.mainSpine.tint = 0xffffff;
            // @ts-ignore
            this.mainSpine.filters = null;
        }
    }
}
